import { render, staticRenderFns } from "./BaseThumbnailImage.vue?vue&type=template&id=31c3db18&"
import script from "./BaseThumbnailImage.vue?vue&type=script&lang=js&"
export * from "./BaseThumbnailImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports